/*===================================================================
=       USER AUTH MAPSTATE                                           =
====================================================================*/

import { IRootState } from "../../../redux/rootReducer";


export const userAuthMapState = (state: IRootState) => ({userAuth: state.userAuth});
